import XPrimaryFive from './XPrimaryFive.vue'
export default XPrimaryFive 